import React from 'react';
import _, { isEmpty } from 'lodash';

import history from '../../history';
import { SpinnerManager } from '../../components/VSpinner/SpinnerManager';
import VContentContainer from '../../components/VContentContainer/VContentContainer';
import VCheckboxGroup from '../../components/VCheckboxGroup/VCheckboxGroup';
import VFilterContainer from '../../components/VFilterContainer/VFilterContainer';
import VMainContainer from '../../components/VMainContainer/VMainContainer';
import VDatePicker from '../../components/VDatePicker/VDatePicker';
import VDropdown from '../../components/VDropdown/VDropdown';
import { extractDate, getDayAheadForGivenDate} from '../../helpers/generalHelper';
import { handleApiError, alertError, alertSuccess, specifyErrorMessage } from '../../helpers/errorHelper';
import { portalMessages } from '../../helpers/portalMessages';
import { getCounterPartyDailyEnergyCosts, getCounterPartyDailyEnergyCostsFile } from '../../apis/vitusApi';
import { getLocalStorage, setLocalStorage } from '../../helpers/localStorageHelper';
import FileSaver from 'file-saver';

class DailyEnergyCosts extends React.Component {

    spinner = new SpinnerManager(history.location.pathname);
    
    dailyEnergyCostHeaderList = ['Exchange', 'Bank Info',
                                 'DAM Energy Amounts (Mwhs)', 'DAM Energy Cost / Revenue (€)',
                                 'IDM Energy Amounts (Mwhs)', 'IDM Energy Cost / Revenue (€)',
                                 'Daily Total Energy Amounts (Mwhs)',
                                 'Total Energy Cost / Revenue (€)', 'VAT Inc. Total Energy Cost / Revenue (€)']
    localDailyEnergyCostHeaderList = ['Exchange', 'Bank Info',
                                      'DAM Energy Amounts (Mwhs)', 'DAM Energy Cost / Revenue (€)',
                                      'IDM Energy Amounts (Mwhs)', 'IDM Energy Cost / Revenue (€)',
                                      'Daily Total Energy Amounts (Mwhs)',
                                      'Total Energy Cost / Revenue Local Currency',
                                      'Total Energy Cost / Revenue Local Currency w/VAT',
                                      'Turnover and Settlement Fee w/VAT', 'Total Energy Cost w/VAT']

    weeklyEnergyCostHeaderList = ['Date', 'Daily Total Energy Amounts (Mwhs)', 'Total Energy Cost / Revenue (€)']

    customEnergyCostColumns = [
        {key: 'exchange', label: 'Exchange'},
        {key: 'dam_buy_date', label: 'DAM Buy Date'},
        {key: 'dam_buy_amount', label: 'DAM Buy Net Amount (Mwhs)'},
        {key: 'dam_buy_cost', label: 'DAM Buy Net Cost/Revenue (€)'},
        {key: 'dam_sell_date', label: 'DAM Sell Date'},
        {key: 'dam_sell_amount', label: 'DAM Sell Net Amount (Mwhs)'},
        {key: 'dam_sell_cost', label: 'DAM Sell Net Cost/Revenue (€)'},
        {key: 'idm_buy_date', label: 'IDM Buy Date'},
        {key: 'idm_buy_amount', label: 'IDM Buy Net Amount (Mwhs)'},
        {key: 'idm_buy_cost', label: 'IDM Buy Net Cost/Revenue (€)'},
        {key: 'idm_sell_date', label: 'IDM Sell Date'},
        {key: 'idm_sell_amount', label: 'IDM Sell Net Amount (Mwhs)'},
        {key: 'idm_sell_cost', label: 'IDM Sell Net Cost/Revenue (€)'},
        {key: 'Total Energy Amounts (Mwhs)', label: 'Total Energy Amounts (Mwhs)'},
        {key: 'Total Energy Cost / Revenue (€)', label: 'Total Energy Cost / Revenue (€)'},
    ]

    idmContinuousColumns = [
        {key: 'country_code', label: 'Country'},
        {key: 'grid', label: 'Grid'},
        {key: 'buy_volume', label: 'Buy Volume (Mwhs)'},
        {key: 'sell_volume', label: 'Sell Volume (Mwhs)'},
        {key: 'net_position', label: 'Net Position (Mwhs)'},
        {key: 'balance', label: 'Balance (€ / £)'},
    ]

    ipexWeekOptions = [
        {value: 1, label: '1 Week'},
        {value: 2, label: '2 Week'}
    ]

    counterParties = {
        Energovia: {label: "Energovia", name: "Energovia"},
        VitusCapital: {label: "Vitus Capital", name: "Vitus Capital"}
    }

    errorMessages = {
        Default: portalMessages.UNEXPECTED_ERROR_OCCURED,
        NotFound: portalMessages.PARAMETERS.NO_OFFER_PARAMETERS_FOUND,
        MissingParameter: {
            "exchange_date": portalMessages.DATE_SELECTION,
            "counter_party": portalMessages.SELECT_COUNTER_PARTY,
        },
        InvalidData: {
            "exchange_date": portalMessages.INVALIED_REQUESTED_DATE,
            "buy": portalMessages.EXCHANGE_RESULTS.INVALID_BUY_VALUES,
            "sell": portalMessages.EXCHANGE_RESULTS.INVALID_SELL_VALUES,
        }
    };

    state = {
        selectedDate: this.getDefaultDate(),
        counterPartyOptions: [],
        selectedCounterParty: getLocalStorage('dailyEnergyCosts', 'dropdown', 'selectedCounterParty') || null,
        selectedCounterPartyOption: null,
        dailyEnergyCostsList: [],
        weeklyEnergyCostsList: [],
        customEnergyCostsList: [],
        idmContinuous: null,
        exclude: 'cagatay',
        selectedIpexWeekOption: {value: 1, label: '1 Week'},
        paymentDate: `${new Date().getFullYear()}-00-00`,
        defaultFormatOptions: {
            SpecialExchangeFormat: {title: "Included", checked: true},
        },
        activeFilter: {
            requestedDate: null,
            counter_party: this.storedActiveFilter?.counter_party,
            include_henex_ibex: this.storedActiveFilter?.include_henex_ibex,
            exclude: '',
            ipex_weeks: 1
        },
        activeFilterToDisplay: [],
        damDate: null,
        idmDate: null,
        bgnRate: null,
        ronRate: null,
        exchange_warnings: []
    }

    getDefaultDate(){
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        return today.setDate(today.getDate());
    }

    getCounterPartyOptions() {
        return Object.keys(this.counterParties).map(c => { return { value: this.counterParties[c].name, label: this.counterParties[c].label } })
    }

    showErrorMessage(error) {
        const { message } = specifyErrorMessage(error, this.errorMessages);

        if (message)
            alertError(message);
    }

    showSuccessMessage(message) {
        alertSuccess(message);
    }

    componentDidMount() {

        let selectedCounterPartyOption;
        const counterPartyOptions = this.getCounterPartyOptions();
        
        if (this.state.activeFilter.counter_party) {
            selectedCounterPartyOption = counterPartyOptions.filter(e => e.label === this.state.activeFilter.counter_party);

            if (selectedCounterPartyOption.length !== 0)
                selectedCounterPartyOption = selectedCounterPartyOption[0];
            else
                selectedCounterPartyOption = "";
        }

        if (!selectedCounterPartyOption) {
            selectedCounterPartyOption = counterPartyOptions[0];
        }

        this.setState({ counterPartyOptions, selectedCounterPartyOption});
        
        const filter = {
                requested_date: extractDate(this.state.selectedDate),
                counter_party: selectedCounterPartyOption.value,
                include_henex_ibex: this.state.defaultFormatOptions["SpecialExchangeFormat"].checked,
                exclude: this.state.exclude,
                ipex_weeks: this.state.selectedIpexWeekOption.value
        };
        
        this.refreshDailyEnergyCostsAsync(filter);
        
    }

    onShowButtonClick = () => {

        if (!this.state.selectedDate) {
            this.showErrorMessage(portalMessages.DATE_SELECTION);
            return;
        }

        if (!this.state.selectedCounterPartyOption || isEmpty(this.state.selectedCounterPartyOption)) {
            this.showErrorMessage(portalMessages.SELECT_COUNTER_PARTY);
            return;
        }

        const filter = {
            requested_date: extractDate(this.state.selectedDate),
            counter_party: this.state.selectedCounterPartyOption.value,
            include_henex_ibex: this.state.defaultFormatOptions["SpecialExchangeFormat"].checked,
            exclude: this.state.exclude,
            ipex_weeks: this.state.selectedIpexWeekOption.value
        };

        this.refreshDailyEnergyCostsAsync(filter);

    }

    refreshDailyEnergyCostsAsync = async (filter) => {
        if (!filter)
            filter = {
                requested_date: this.state.activeFilter.requestedDate,
                counter_party: this.state.activeFilter.counter_party,
                include_henex_ibex: this.state.activeFilter.include_henex_ibex,
                exclude: this.state.activeFilter.exclude,
                ipex_weeks: this.state.activeFilter.ipex_weeks
            };

        return await this.getDailyEnergyCostsAsync(filter)
    }

    getDailyEnergyCostsAsync = async (filter) => {

        this.spinner.showSpinner('getDailyEnergyCosts');

        try {

            let response;

            try {
                response = await getCounterPartyDailyEnergyCosts(filter);
            } catch (error) {
                handleApiError(error);
                return;
            }

            if (response.data.success) {
                
                if (response.data.success.daily_energy_costs_list.length === 0){
                    let dam_date = response.data.success.dam_date;
                    let idm_date = response.data.success.idm_date;
                    alertSuccess(portalMessages.DAILY_ENERGY_COSTS.NO_DAILY_ENERGY_COSTS.replace('[DAM_DATE]', dam_date).replace('[IDM_DATE]', idm_date))
                    this.setState({
                        dailyEnergyCostsList: [],
                        weeklyEnergyCostsList: response.data.success.weekly_energy_costs_list || [],
                        customEnergyCostsList: response.data.success.custom_energy_costs || [],
                        idmContinuous: response.data.success.idm_continuous || null,
                        damDate: response.data.success.dam_date,
                        idmDate: response.data.success.idm_date,
                        bgnRate: response.data.success.bgn_rate,
                        ronRate: response.data.success.ron_rate,
                        activeFilter: {
                            requestedDate: filter.requested_date,
                            counter_party: filter.counter_party,
                            include_henex_ibex: filter.include_henex_ibex,
                            exclude: filter.exclude,
                            ipex_weeks: filter.ipex_weeks
                        },
                        activeFilterToDisplay: [
                            { label: "Date", value: filter.requested_date },
                            { label: "Counter Party", value: filter.counter_party },
                            { label: "IBEX - HENEX Special Format", value: filter.include_henex_ibex ? "Included": "Not Included"},
                            ...(filter.exclude ? [{ label: "Exclude", value: filter.exclude }] : []),
                            ...(filter.ipex_weeks === 2 ? [{ label: "IPEX Week", value: "2 Week" }] : [])
                        ],
                        exchange_warnings: [] 
                    }, () => {
                        setLocalStorage('dailyEnergyCosts', 'filters', 'activeFilter',
                            { requestedDate: filter.requested_date, counter_party: filter.counter_party, include_henex_ibex: filter.include_henex_ibex });
                    });

                }
                else{
                    this.setState({
                        dailyEnergyCostsList: response.data.success.daily_energy_costs_list,
                        weeklyEnergyCostsList: response.data.success.weekly_energy_costs_list || [],
                        customEnergyCostsList: response.data.success.custom_energy_costs || [],
                        idmContinuous: response.data.success.idm_continuous || null,
                        damDate: response.data.success.dam_date,
                        idmDate: response.data.success.idm_date,
                        bgnRate: response.data.success.bgn_rate,
                        ronRate: response.data.success.ron_rate,
                        activeFilter: {
                            requestedDate: filter.requested_date,
                            counter_party: filter.counter_party,
                            include_henex_ibex: filter.include_henex_ibex,
                            exclude: filter.exclude,
                            ipex_weeks: filter.ipex_weeks
                        },
                        activeFilterToDisplay: [
                            { label: "Date", value: filter.requested_date },
                            { label: "Counter Party", value: filter.counter_party },
                            { label: "IBEX - HENEX Special Format", value: filter.include_henex_ibex ? "Included": "Not Included"},
                            ...(filter.exclude ? [{ label: "Exclude", value: filter.exclude }] : []),
                            ...(filter.ipex_weeks === 2 ? [{ label: "IPEX Week", value: "2 Week" }] : [])
                        ],
                        exchange_warnings: response.data.success.exchange_warnings
                    }, () => {
                        setLocalStorage('dailyEnergyCosts', 'filters', 'activeFilter',
                            { requestedDate: filter.requested_date, counter_party: filter.counter_party, include_henex_ibex: filter.include_henex_ibex });
                    });
                }
            } else if (response.data.error) {
                this.setState({
                    dailyEnergyCostsList: [],
                    weeklyEnergyCostsList: [],
                    customEnergyCostsList: [],
                    idmContinuous: null,
                    damDate: null,
                    idmDate: null,
                    bgnRate: null,
                    ronRate: null,
                    activeFilter: {
                        requestedDate: filter.requested_date,
                        counter_party: filter.counter_party,
                        include_henex_ibex: filter.include_henex_ibex,
                        exclude: filter.exclude,
                        ipex_weeks: filter.ipex_weeks
                    },
                    activeFilterToDisplay: [
                        { label: "Date", value: filter.requested_date },
                        { label: "Counter Party", value: filter.counter_party },
                        { label: "IBEX - HENEX Special Format", value: filter.include_henex_ibex ? "Included": "Not Included"},
                        ...(filter.exclude ? [{ label: "Exclude", value: filter.exclude }] : []),
                        ...(filter.ipex_weeks === 2 ? [{ label: "IPEX Week", value: "2 Week" }] : [])
                    ],
                    exchange_warnings: []
                }, () => {
                    setLocalStorage('dailyEnergyCosts', 'filters', 'activeFilter',
                        { requestedDate: filter.requested_date, counter_party: filter.counter_party, include_henex_ibex: filter.include_henex_ibex });
                });

                this.showErrorMessage(response.data.error);

            } else {
                alertError(portalMessages.UNEXPECTED_ERROR_OCCURED);
            }

        } catch (error) {
            alertError(portalMessages.UNEXPECTED_ERROR_OCCURED);

        } finally {
            this.spinner.hideSpinner('getDailyEnergyCosts');
        }
    }

    renderDailyEnergyCosts() {

        if (this.state.dailyEnergyCostsList.length > 0){
            return (
                <div>
                    <div style={{textAlign: 'center', backgroundColor: '#a5a5a5', marginTop: '30px', maxWidth: '1735px', color: 'white'}}>
                    {'Total Balance (DAM + IDM)'}
                    </div>
                    {this.renderDailyEnergyCostsTables(this.state.dailyEnergyCostsList)}
                    {this.renderCurrencyDateTable()}
                    {this.renderSpecialWarnings()}
                </div>
            );
        }
    }

    formatNumber = (value) => Number(value).toLocaleString(undefined, {maximumFractionDigits: 2});

    hasIdmContinuous(){
        const idmContinuous = this.state.idmContinuous;
        return !!(idmContinuous && idmContinuous.records && idmContinuous.records.length > 0);
    }

    getIdmContinuousTotals(){
        // GB balances are in GBP, every other country in EUR, so balances are totalled per currency.
        const idmContinuous = this.state.idmContinuous;
        const totals = idmContinuous.records.reduce((t, r) => ({
            buy_volume: t.buy_volume + r.buy_volume,
            sell_volume: t.sell_volume + r.sell_volume,
            net_position: t.net_position + r.net_position,
            balanceByCurrency: {
                ...t.balanceByCurrency,
                [this.getIdmContinuousCurrency(r.country_code)]: (t.balanceByCurrency[this.getIdmContinuousCurrency(r.country_code)] || 0) + r.balance
            }
        }), {buy_volume: 0, sell_volume: 0, net_position: 0, balanceByCurrency: {}});

        // EUR/GBP = GBP per 1 EUR, so GBP amounts are divided by it to get EUR.
        // Without a rate the EUR balance can only be computed when there is no GBP balance.
        const eurGbpRate = idmContinuous.eur_gbp_rate;
        const eurBalance = totals.balanceByCurrency['€'] || 0;
        const gbpBalance = totals.balanceByCurrency['£'];
        if (gbpBalance === undefined)
            totals.balanceEur = eurBalance;
        else
            totals.balanceEur = eurGbpRate ? eurBalance + gbpBalance / eurGbpRate : null;

        return totals;
    }

    getIdmContinuousCurrency(countryCode){
        return countryCode === 'GB' ? '£' : '€';
    }

    renderIdmContinuous(){

        if (!this.hasIdmContinuous())
            return;

        const idmContinuous = this.state.idmContinuous;
        const getCurrency = (countryCode) => this.getIdmContinuousCurrency(countryCode);
        const records = idmContinuous.records;
        const totals = this.getIdmContinuousTotals();
        const rows = [...records, {country_code: 'Total', grid: '', ...totals}];
        const formatNumber = this.formatNumber;
        const eurGbpRate = idmContinuous.eur_gbp_rate;
        const formatTotalBalance = (balanceByCurrency) => {
            if (totals.balanceEur !== null)
                return `€ ${formatNumber(totals.balanceEur)}`;
            return Object.entries(balanceByCurrency).map(([currency, value]) => `${currency} ${formatNumber(value)}`).join(' / ');
        };
        const formatBalance = (row) => row.country_code === 'Total'
            ? formatTotalBalance(row.balanceByCurrency)
            : `${getCurrency(row.country_code)} ${formatNumber(row.balance)}`;

        return (
            <div>
                <div style={{textAlign: 'center', backgroundColor: '#a5a5a5', marginTop: '30px', maxWidth: '1735px', color: 'white'}}>
                {'IDM Continuous (ECC)'}
                </div>
                <div style={{display: 'grid', marginTop: '30px', overflowX: 'auto'}}>
                    <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                        <thead>
                            <tr>
                            {this.idmContinuousColumns.map(c => {
                                return (
                                    <th style={{padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: c.key === 'country_code' ? '#8faadc' : '#dae3f3', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'}}>
                                        {c.label}
                                    </th>
                                )
                            })}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(row => {
                                const fontWeight = row.country_code === 'Total' ? 'bold' : 'normal';
                                return (<tr>
                                    {this.idmContinuousColumns.map(c => {
                                        if (c.key === 'country_code'){
                                            return (<td style={{backgroundColor: '#fbe5d6', textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                                {row[c.key]}
                                                </td>)
                                        }
                                        else if (c.key === 'grid'){
                                            return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                                {row[c.key]}
                                                </td>)
                                        }
                                        else if (c.key === 'balance'){
                                            return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                                {formatBalance(row)}
                                                </td>)
                                        }
                                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                            {formatNumber(row[c.key])}
                                            </td>)
                                    })}
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
                <div style={{display: 'grid', marginTop: '20px'}}>
                    <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '200px', maxHeight: '20px'}}>
                        <tbody>
                            <tr>
                                <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'EUR/GBP'}</td>
                                <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>{eurGbpRate || '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {!eurGbpRate &&
                    <div style={{marginTop: '10px', maxWidth: '1735px', color: 'black', fontWeight: 'bold'}}>
                        {'EUR/GBP rate is not available, GB balance is not converted in the total.'}
                    </div>}
                <div style={{marginTop: '10px', maxWidth: '1735px', color: 'black'}}>
                    {`Period: ${idmContinuous.start} - ${idmContinuous.end}`}
                </div>
                {idmContinuous.comment &&
                    <div style={{maxWidth: '1735px', color: 'black'}}>
                        {idmContinuous.comment}
                    </div>}
            </div>
        );
    }

    getDamIdmContinuousSummaryRows(){
        // DAM and IDM totals come from the Total row of the Non Local (EUR) table.
        const nonLocalTotal = this.state.dailyEnergyCostsList.find(
            d => d.Type === 'Non Local' && d.Exchange === 'Total') || {};
        const idmContinuousTotals = this.getIdmContinuousTotals();

        const rows = [
            {label: 'DAM', amount: nonLocalTotal['DAM Energy Amounts (Mwhs)'] || 0,
             cost: nonLocalTotal['DAM Energy Cost / Revenue (€)'] || 0},
            {label: 'IDM', amount: nonLocalTotal['IDM Energy Amounts (Mwhs)'] || 0,
             cost: nonLocalTotal['IDM Energy Cost / Revenue (€)'] || 0},
            {label: 'IDM Continuous (ECC)', amount: idmContinuousTotals.net_position,
             cost: idmContinuousTotals.balanceEur},
        ];
        rows.push({
            label: 'Total',
            amount: rows.reduce((sum, r) => sum + r.amount, 0),
            cost: rows.some(r => r.cost === null) ? null : rows.reduce((sum, r) => sum + r.cost, 0)
        });
        return rows;
    }

    getIdmContinuousExportData(){
        if (!this.hasIdmContinuous())
            return null;

        const idmContinuous = this.state.idmContinuous;
        const round = (value) => Math.round(value * 100) / 100;
        const totals = this.getIdmContinuousTotals();
        const toCurrencyCode = (symbol) => symbol === '£' ? 'GBP' : 'EUR';

        const rows = idmContinuous.records.map(r => ({
            'Country': r.country_code,
            'Grid': r.grid,
            'Currency': toCurrencyCode(this.getIdmContinuousCurrency(r.country_code)),
            'Buy Volume (Mwhs)': round(r.buy_volume),
            'Sell Volume (Mwhs)': round(r.sell_volume),
            'Net Position (Mwhs)': round(r.net_position),
            'Balance': round(r.balance)
        }));
        // Without an EUR/GBP rate the total balance cannot be a single EUR number.
        const totalBalance = totals.balanceEur !== null ? round(totals.balanceEur)
            : Object.entries(totals.balanceByCurrency).map(([c, v]) => `${toCurrencyCode(c)} ${this.formatNumber(v)}`).join(' / ');
        rows.push({
            'Country': 'Total',
            'Grid': '',
            'Currency': totals.balanceEur !== null ? 'EUR' : '',
            'Buy Volume (Mwhs)': round(totals.buy_volume),
            'Sell Volume (Mwhs)': round(totals.sell_volume),
            'Net Position (Mwhs)': round(totals.net_position),
            'Balance': totalBalance
        });

        return {
            rows: rows,
            eur_gbp_rate: idmContinuous.eur_gbp_rate,
            start: idmContinuous.start,
            end: idmContinuous.end,
            comment: idmContinuous.comment,
            exclude: this.state.activeFilter.exclude,
            summary_rows: this.getDamIdmContinuousSummaryRows().map(r => ({
                'Market': r.label,
                'Energy Amounts (Mwhs)': round(r.amount),
                'Currency': 'EUR',
                'Energy Cost / Revenue': r.cost === null ? null : round(r.cost)
            }))
        };
    }

    renderDamIdmContinuousSummary(){

        if (!this.hasIdmContinuous())
            return;

        const rows = this.getDamIdmContinuousSummaryRows();

        const thStyle = {padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: '#dae3f3', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'};

        return (
            <div>
                <div style={{textAlign: 'center', backgroundColor: '#a5a5a5', marginTop: '30px', maxWidth: '1735px', color: 'white'}}>
                {'DAM + IDM + IDM Continuous (ECC)'}
                </div>
                <div style={{display: 'grid', marginTop: '30px', overflowX: 'auto'}}>
                    <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                        <thead>
                            <tr>
                                <th style={{...thStyle, backgroundColor: '#8faadc'}}>Market</th>
                                <th style={thStyle}>Energy Amounts (Mwhs)</th>
                                <th style={thStyle}>Energy Cost / Revenue (€)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(row => {
                                const fontWeight = row.label === 'Total' ? 'bold' : 'normal';
                                return (<tr>
                                    <td style={{backgroundColor: '#fbe5d6', textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                        {row.label}
                                    </td>
                                    <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                        {this.formatNumber(row.amount)}
                                    </td>
                                    <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                        {row.cost === null ? '-' : `€ ${this.formatNumber(row.cost)}`}
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderWeeklyEnergyCosts(){

        if (this.state.weeklyEnergyCostsList.length > 0){
            const data = this.state.weeklyEnergyCostsList;
            const exchanges = Object.keys(data.reduce((r, {Exchange}) => (r[Exchange]='', r), {}))
                .sort((a, b) => (a === 'IPEX') - (b === 'IPEX'));
            const dates = Object.keys(data.reduce((r, {Date}) => (r[Date]='', r), {}))
                .sort((a, b) => (a === 'Total') - (b === 'Total') || a.localeCompare(b));

            return (
                <div>
                    <div style={{textAlign: 'center', backgroundColor: '#a5a5a5', marginTop: '30px', maxWidth: '1735px', color: 'white'}}>
                    {'Weekly Energy Cost / Revenue'}
                    </div>
                    <div style={{display: 'grid', marginTop: '30px', overflowX: 'auto'}}>
                        <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                            <thead>
                                {this.renderWeeklyEnergyCostsHeaders(exchanges)}
                            </thead>
                            <tbody>
                                {this.renderWeeklyEnergyCostsRows(data, exchanges, dates)}
                            </tbody>
                        </table>
                    </div>
                    {this.renderPaymentDateTable()}
                </div>
            );
        }
    }

    renderPaymentDateTable(){
        return (
            <div style={{display: 'grid', marginTop: '20px', marginBottom: '20px'}}>
                <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '375px', maxHeight: '20px'}}>
                    <tbody>
                        <tr>
                            <td style={{textAlign: 'center', maxWidth: '2px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'Payment Date'}</td>
                            <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>
                                <input
                                    type="text"
                                    style={{textAlign: 'center', width: '100%', border: 'none', background: 'transparent', padding: 0, font: 'inherit'}}
                                    value={this.state.paymentDate}
                                    onChange={(e) => this.setState({ paymentDate: e.target.value })}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderWeeklyEnergyCostsHeaders(exchanges){
        const thStyle = {padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: '#dae3f3', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'};
        return (
            <React.Fragment>
                <tr>
                    <th rowSpan={2} style={{...thStyle, backgroundColor: '#8faadc'}}>Date</th>
                    {exchanges.map(exchange => (
                        <th colSpan={2} style={thStyle}>{exchange}</th>
                    ))}
                </tr>
                <tr>
                    {exchanges.map(() => (
                        <React.Fragment>
                            <th style={thStyle}>Amount (Mwhs)</th>
                            <th style={thStyle}>Cost / Revenue (€)</th>
                        </React.Fragment>
                    ))}
                </tr>
            </React.Fragment>
        );
    }

    renderWeeklyEnergyCostsRows(data, exchanges, dates){
        return dates.map(date => {
            const isTotalRow = date === 'Total';
            const fontWeight = isTotalRow ? 'bold' : 'normal';
            return (
                <tr>
                    <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>{date}</td>
                    {exchanges.map(exchange => {
                        const row = data.find(d => d.Date === date && d.Exchange === exchange);
                        if (!row){
                            return (
                                <React.Fragment>
                                    <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>-</td>
                                    <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>-</td>
                                </React.Fragment>
                            );
                        }
                        return (
                            <React.Fragment>
                                <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                    {row['Daily Total Energy Amounts (Mwhs)'].toLocaleString()}
                                </td>
                                <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                    {`${row['Currency']} ` + row['Total Energy Cost / Revenue (€)'].toLocaleString()}
                                </td>
                            </React.Fragment>
                        );
                    })}
                </tr>
            );
        });
    }

    renderCustomEnergyCosts(){

        if (this.state.customEnergyCostsList.length > 0){
            return (
                <div>
                    <div style={{textAlign: 'center', backgroundColor: '#a5a5a5', marginTop: '30px', maxWidth: '1735px', color: 'white'}}>
                    {'Custom Energy Cost / Revenue'}
                    </div>
                    <div style={{display: 'grid', marginTop: '30px', overflowX: 'auto'}}>
                        <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                            <thead>
                                <tr>
                                {this.customEnergyCostColumns.map(c => {
                                    return (
                                        <th style={{padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: c.key === 'exchange' ? '#8faadc' : '#dae3f3', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'}}>
                                            {c.label}
                                        </th>
                                    )
                                })}
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderCustomEnergyCostsRows(this.state.customEnergyCostsList)}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }
    }

    renderCustomEnergyCostsRows(data){
        return (data.map(row => {
            return (<tr>
                {this.customEnergyCostColumns.map(c => {
                    if (c.key === 'exchange'){
                        return (<td style={{backgroundColor: '#fbe5d6', textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>
                            {row[c.key]}
                            </td>)
                    }
                    else if (c.key.endsWith('_date')){
                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>
                            {row[c.key]}
                            </td>)
                    }
                    else if (c.key.endsWith('_amount')){
                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>
                            {row[c.key].toLocaleString()}
                            </td>)
                    }
                    else if (c.key === 'Total Energy Amounts (Mwhs)'){
                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight: 'bold'}}>
                            {row[c.key].toLocaleString()}
                            </td>)
                    }
                    else if (c.key === 'Total Energy Cost / Revenue (€)'){
                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight: 'bold'}}>
                            {`${row['Currency']} ` + row[c.key].toLocaleString()}
                            </td>)
                    }
                    else{
                        return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>
                            {`${row['Currency']} ` + row[c.key].toLocaleString()}
                            </td>)
                    }
                })}
            </tr>)
        }))
    }

    renderSpecialWarnings(){

        return this.state.exchange_warnings.map(exchange_warning => {
            return <div style={{marginTop: '30px', maxWidth: '1735px', color: 'black', fontWeight: 'bold'}}>    
                {exchange_warning}
            </div>
        })
     
    }

    renderCurrencyDateTable(){

        return (
            <div style={{display: 'grid', marginBottom: '20px', marginTop: '20px'}}>

                {<table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '375px', maxHeight: '20px'}}>
                    <tbody>
                        <tr>
                        <td style={{textAlign: 'center', maxWidth: '2px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'DAM Date'}</td>
                        <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>{this.state.damDate}</td>
                        </tr>
                        <tr>
                        <td style={{textAlign: 'center', maxWidth: '2px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'IDM Date'}</td>
                        <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>{this.state.idmDate}</td>

                        </tr>
                    </tbody>
                </table>}
                {this.state.activeFilter.counter_party !== 'Vitus Capital' ?
                    <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '200px', maxHeight: '20px'}}>
                    <tbody>
                        <tr>
                            <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'EUR/BGN'}</td>
                            <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>{this.state.bgnRate}</td>
                        </tr>
                        <tr>
                            <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', backgroundColor: '#dae3f3', border: 'solid 3px #979797'}}>{'EUR/RON'}</td>
                            <td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word'}}>{this.state.ronRate}</td>
                        </tr>         
                    </tbody>
                </table> : ''}
            </div>
        )
    }

    renderHeaders(headerList){
        return (
            <React.Fragment>
                <tr>
                {
                   headerList.map(h => {
                    if (h === 'Exchange'){
                        return (
                            <th style={{padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: '#8faadc', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'}}>
                                {h}
                            </th>
                        )
                    }
                    else{
                        return (
                            <th style={{padding: '2px 8px', borderBottom: 'solid 3px #979797', borderRight: 'solid 3px #979797', backgroundColor: '#dae3f3', textAlign: 'center', maxWidth: '10px', wordWrap: 'break-word'}}>
                                {h}
                            </th>
                        )    
                    }
                   })
                }
                </tr>         
            </React.Fragment>
            
        );
    }

    renderRows(data, headerList){
        let exchanges = Object.keys(data.reduce((r, {Exchange}) => (r[Exchange]='', r), {}))
        return (exchanges.map(e => {
            let exchange_data = data.find(d => d.Exchange === e);
            const fontWeight = exchange_data.Exchange === 'Total' ? 'bold' : 'normal';
            return (<tr>
                {headerList.map(h => {
                    if (h === 'Exchange' || h === 'Bank Info'){
                        if (h === 'Exchange'){
                            return (<td style={{backgroundColor: '#fbe5d6', textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                {exchange_data[h]}
                                </td>)

                        }
                        else{
                            return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                                {exchange_data[h]}
                                </td>)

                        }
                    }
                    else{
                        const isAmountField = h === 'Daily Total Energy Amounts (Mwhs)' ||
                            h === 'DAM Energy Amounts (Mwhs)' || h === 'IDM Energy Amounts (Mwhs)';
                        if (!isAmountField){
                            if (h === 'Total Energy Cost w/VAT'){
                                return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight: 'bold'}}>
                                {exchange_data[h].toLocaleString()}
                                </td>)
                            }
                            // These fields are always EUR-denominated, even in the local-currency table,
                            // so they must use the literal € sign rather than the row's own Currency.
                            const currencyPrefix = h.endsWith('(€)') ? '€' : exchange_data['Currency'];
                            return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                            {`${currencyPrefix} ` + exchange_data[h].toLocaleString()}
                            </td>)
                        }
                        else{
                            return (<td style={{textAlign: 'center', maxWidth: '5px', wordWrap: 'break-word', fontWeight}}>
                            {exchange_data[h].toLocaleString()}
                            </td>)
                        }

                    }
                })}
            </tr>)

        }))
    }

    getPresentHeaders(headerList, data){
        if (data.length === 0){
            return headerList;
        }
        return headerList.filter(h => Object.prototype.hasOwnProperty.call(data[0], h));
    }

    renderDailyEnergyCostsTables(data){

        let types = Object.keys(data.reduce((r, {Type}) => (r[Type]='', r), {}))
        return(
            types.map(t => {
                let table_data = data.filter(d => d.Type === t);
                if (t === 'Non Local'){
                    const headerList = this.getPresentHeaders(this.dailyEnergyCostHeaderList, table_data);
                    return (
                        <div style={{display: 'grid', marginTop: '30px'}}>

                        <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                            <thead>
                                {this.renderHeaders(headerList)}
                            </thead>
                            <tbody>
                                {this.renderRows(table_data, headerList)}
                            </tbody>
                        </table>
                        </div>

                    )
                }
                else{
                    const headerList = this.getPresentHeaders(this.localDailyEnergyCostHeaderList, table_data);
                    return (
                        <div style={{display: 'grid', marginTop: '30px'}}>

                        <table className='table-striped' style={{border: 'solid 3px #dadada', maxWidth: '1735px'}}>
                            <thead>
                                {this.renderHeaders(headerList)}
                            </thead>
                            <tbody>
                                {this.renderRows(table_data, headerList)}
                            </tbody>
                        </table>
                        </div>
                    )
                }
            })
            
            
        )
    }

    exportDailyEnergyCosts = async () => {
        const spinnerKey = this.spinner.showSpinner();

        let response;
        const nonLocalData = this.state.dailyEnergyCostsList.filter(d => d.Type === 'Non Local');
        const localData = this.state.dailyEnergyCostsList.filter(d => d.Type === 'Local');
        const costHeaderList = this.getPresentHeaders(this.dailyEnergyCostHeaderList, nonLocalData);
        const costLocalHeaderList = this.getPresentHeaders(this.localDailyEnergyCostHeaderList, localData);
        let body = {'counter_party': this.state.selectedCounterPartyOption.value, 'requested_date': extractDate(this.state.selectedDate),
                    'daily_energy_cost_data': {'cost_data': this.state.dailyEnergyCostsList, 'cost_header_list': costHeaderList,
                                               'cost_local_header_list': costLocalHeaderList, 'dam_date': this.state.damDate, 'idm_date': this.state.idmDate,
                                               'bgn_rate': this.state.bgnRate, 'ron_rate': this.state.ronRate, 'exchange_warnings': this.state.exchange_warnings,
                                               'weekly_cost_data': this.state.weeklyEnergyCostsList, 'weekly_cost_header_list': this.weeklyEnergyCostHeaderList,
                                               'idm_continuous_data': this.getIdmContinuousExportData(),
                                               'payment_date': this.state.paymentDate}};

        try {
            response = await getCounterPartyDailyEnergyCostsFile(body);
            
            const filename = `Energy Costs / Revenues based on Exchanges ${extractDate(this.state.selectedDate)}.xlsx`;
            const contentType = response.headers["content-type"];

            const blob = new Blob([response.data], { type: contentType });

            if (contentType === 'application/json') {
                //const error = blob.text();
                return;
            }
            
            FileSaver.saveAs(blob, filename)

            return;
        } catch (error) {
            handleApiError(error);
            return false;
        }
        finally{
            this.spinner.hideSpinner(spinnerKey);
        }
    }

    render() {
        return (
            <React.Fragment>
                <VContentContainer title="Daily Energy Costs / Revenues based on Exchanges">
                    <VFilterContainer 
                        showActiveFilter 
                        activeFilter={this.state.activeFilterToDisplay}
                    >
                        <div className="v-filter-group">
                            <div className="v-filter-label v-label">
                                Date
                            </div>
                            <div>
                                <VDatePicker
                                    selectedDate={this.state.selectedDate}
                                    onSelectedDateChange={(selectedDate) => this.setState({ selectedDate })}
                                    maxDate={this.getDefaultDate()}
                                />
                            </div>
                        </div>
                       
                        <div className="v-filter-group">
                            <div className="v-filter-label v-label">
                                Counter Party
                            </div>
                            <div>
                                <VDropdown
                                    width="large"
                                    options={this.state.counterPartyOptions}
                                    value={this.state.selectedCounterPartyOption}
                                    onSelectedOptionChange={(selectedCounterPartyOption) => {
                                        this.setState({
                                             selectedCounterParty: selectedCounterPartyOption.value,
                                             selectedCounterPartyOption: selectedCounterPartyOption
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="v-filter-group">
                            <div className="v-filter-label v-label">
                                IBEX - HENEX Special Format
                            </div>
                            <div>
                                <VCheckboxGroup
                                    items={this.state.defaultFormatOptions}
                                    onCheckChanged={(k, updatedItems) => this.setState({ defaultFormatOptions: { ...updatedItems } })}
                                />
                            </div>
                        </div>

                        {this.state.selectedCounterPartyOption?.value === this.counterParties.Energovia.name &&
                            <div className="v-filter-group">
                                <div className="v-filter-label v-label">
                                    IPEX Week
                                </div>
                                <div>
                                    <VDropdown
                                        width="large"
                                        options={this.ipexWeekOptions}
                                        value={this.state.selectedIpexWeekOption}
                                        onSelectedOptionChange={(selectedIpexWeekOption) => this.setState({ selectedIpexWeekOption })}
                                    />
                                </div>
                            </div>
                        }

                        {this.state.selectedCounterPartyOption?.value === this.counterParties.VitusCapital.name &&
                            <div className="v-filter-group">
                                <div className="v-filter-label v-label">
                                    Exclude
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. test, hedge"
                                        value={this.state.exclude}
                                        onChange={(e) => this.setState({ exclude: e.target.value })}
                                    />
                                    <div className='small text-muted' style={{ margin: '5px 0', maxWidth: '300px' }}>
                                        Used to exclude Vitus Capital continuous executions. Executions whose comment contains any of the given comma-separated keywords are excluded.
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="v-filter-buttons">
                            <button
                                tabIndex={0}
                                className="btn v-button v-filter-button"
                                onClick={this.onShowButtonClick}>
                                <i aria-hidden="true" className="fa fa-search fa-fw" />Show
                             </button>
                        </div>
                    </VFilterContainer>
                    {
                        <React.Fragment>
                            <VMainContainer>
                            <div className='col-12' style={{ textAlign: 'right', margin: '5px 0 0 0', padding: '0' }}>
                                <button className="btn v-button v-tab-button"
                                    onClick={() => this.exportDailyEnergyCosts()}>
                                    <i aria-hidden="true"/>
                                        Export XLSX
                                </button>
                            </div>
                            {this.renderDailyEnergyCosts()}
                            {this.renderIdmContinuous()}
                            {this.renderDamIdmContinuousSummary()}
                            {this.renderWeeklyEnergyCosts()}
                            {this.renderCustomEnergyCosts()}

                            </VMainContainer>
                        </React.Fragment>
                    }
                </VContentContainer>
            </React.Fragment>
        );
    }


}

export default DailyEnergyCosts;